import React from 'react';
import _ from 'lodash';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import metadata from './PolicySummaryAdditionalInterestsComponent.metadata.json5';
import messages from './PolicySummaryAdditionInterestsComponent.messages';

function PolicySummaryAdditionalInterestComponent(props) {
    const {
        model: policyDetails, isPUP, gpaMode
    } = props;

    const translator = useTranslator();

    const generateOverrides = () => {
        const overrides = policyDetails.additionalInterests.value.map((interest, index) => {
            const formatVehicleDetails = () => {
                if (!isPUP) {
                    return (
                        <>
                            <strong>
                                {interest.vehicle.year}
                                &nbsp;
                                {interest.vehicle.make}
                            </strong>
                            &nbsp;
                            {interest.vehicle.model}
                            &nbsp;
                            {interest.vehicle.trim_ML}
                        </>
                    );
                }
                return '';
            };

            const getDisplayName = () => {
                return (interest.displayFullName_Ext) ? interest.displayFullName_Ext : interest.name;
            };
            return {
                [`additionalInterestType${index}`]: {
                    visible: !gpaMode,
                    content: `${interest.type}`
                },
                [`agentInterestType${index}`]: {
                    visible: gpaMode,
                    content: `${interest.type}`
                },
                [`vehicleDetails${index}`]: {
                    content: formatVehicleDetails()
                },
                [`interestPartyName${index}`]: {
                    content: getDisplayName()
                },
                [`interestAddressLine1${index}`]: {
                    visible: !_.isUndefined(interest.address.addressLine1),
                    content: `${interest.address.addressLine1}`
                },
                [`interestAddressLine2${index}`]: {
                    visible: !_.isUndefined(interest.address.addressLine2),
                    content: `${interest.address.addressLine2}`
                },
                [`interestAddressLine3${index}`]: {
                    visible: !_.isUndefined(interest.address.addressLine3),
                    content: `${interest.address.addressLine3}`
                },
                [`interestCityStatePostalCode${index}`]: {
                    content: `${interest.address.city}, ${interest.address.state} ${interest.address.postalCode}`
                },
                [`interestLoanNumber${index}`]: {
                    visible: !isPUP && !_.isUndefined(interest.loanNumber),
                    content: `${translator(messages.loanNumber)}${interest.loanNumber}`
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrideProps = {
        additionalInterest: {
            data: policyDetails.additionalInterests.value
        },
        ...generateOverrides()
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            model={policyDetails}
        />
    );
}

PolicySummaryAdditionalInterestComponent.propTypes = {
    model: PropTypes.shape({}).isRequired,
    isPUP: PropTypes.bool,
    gpaMode: PropTypes.bool
};

PolicySummaryAdditionalInterestComponent.defaultProps = {
    isPUP: false,
    gpaMode: false
};

export default PolicySummaryAdditionalInterestComponent;
